// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c21b8768","513":"eedf97fa","703":"b40ff90e","787":"e0684799"}[chunkId] + ".chunk.js";
};